
export default function Contact() {
  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="bg-gray-900 rounded-3xl p-16 shadow-2xl">
          {/* Upper Section */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 mb-16">
            {/* Left Column - Newsletter */}
            <div className="lg:col-span-6">
              <h3 className="text-6xl font-light text-white mb-6">Stay Connected</h3>
              <p className="text-gray-400 text-base mb-8">Get updates about our latest products</p>
            </div>

            {/* Center Column - Navigation */}
            <div className="lg:col-span-3">
              <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-6">Navigation</h4>
              <ul className="space-y-4">
                <li>
                  <a href="#products" className="text-gray-300 hover:text-white transition-colors underline cursor-pointer">
                    Products
                  </a>
                </li>
                <li>
                  <a href="#about" className="text-gray-300 hover:text-white transition-colors underline cursor-pointer">
                    About
                  </a>
                </li>
                <li>
                  <a href="#features" className="text-gray-300 hover:text-white transition-colors underline cursor-pointer">
                    Features
                  </a>
                </li>
                <li>
                  <a href="#contact" className="text-gray-300 hover:text-white transition-colors underline cursor-pointer">
                    Contact
                  </a>
                </li>
              </ul>
            </div>

            {/* Right Column - Contact Info */}
            <div className="lg:col-span-3">
              <h4 className="text-sm font-semibold text-white uppercase tracking-wider mb-6">Contact</h4>
              <div className="space-y-6">
                <div>
                  <div className="flex items-start gap-3 mb-2">
                    <i className="ri-phone-line text-teal-400 text-lg mt-1"></i>
                    <div>
                      <p className="text-sm text-gray-400 mb-1">Phone</p>
                      <a href="tel:+15739283553" className="text-white hover:text-teal-400 transition-colors cursor-pointer">
                        +1 5739283553
                      </a>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="flex items-start gap-3 mb-2">
                    <i className="ri-mail-line text-teal-400 text-lg mt-1"></i>
                    <div>
                      <p className="text-sm text-gray-400 mb-1">Email</p>
                      <a href="mailto:info@metosdoonis.com" className="text-white hover:text-teal-400 transition-colors cursor-pointer">
                        info@metosdoonis.com
                      </a>
                    </div>
                  </div>
                </div>
                <div className="pt-4">
                  <div className="flex items-start gap-3">
                    <i className="ri-map-pin-line text-teal-400 text-lg mt-1"></i>
                    <div>
                      <p className="text-sm text-gray-400 mb-2">Address</p>
                      <p className="text-white leading-relaxed">
                        Kurska 1<br />
                        Nis, 706529<br />
                        Serbia
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pt-12 border-t border-gray-800">
            <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
              <div className="flex items-center gap-6">
                <a href="#" className="text-gray-400 hover:text-white transition-colors underline cursor-pointer text-sm">
                  LinkedIn
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors underline cursor-pointer text-sm">
                  Twitter
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors underline cursor-pointer text-sm">
                  GitHub
                </a>
              </div>
              <p className="text-gray-400 text-sm">© 2025 METOS DOO NIS. All rights reserved.</p>
              <div className="flex items-center gap-6">
                <a href="#" className="text-gray-400 hover:text-white transition-colors underline cursor-pointer text-sm">
                  Privacy Policy
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors underline cursor-pointer text-sm">
                  Terms of Service
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}